import { render, staticRenderFns } from "./M22_F7_S45.vue?vue&type=template&id=137c6364&scoped=true"
import script from "./M22_F7_S45.vue?vue&type=script&lang=js"
export * from "./M22_F7_S45.vue?vue&type=script&lang=js"
import style0 from "./M22_F7_S45.vue?vue&type=style&index=0&id=137c6364&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137c6364",
  null
  
)

export default component.exports